import request from '@/http/zhaocai'
const url = process.env.VUE_APP_API
// const url = 'http://swj.ngrok.gcw.net:90'
const apiLnquiryLetter = {
    // 验证当前用户是否允许函询--招标
    getCheckAllowTenderQuestion: (tenderNo) => request.get(`${url}/sv1/tender/userInquiry/checkAllowTenderQuestion/${tenderNo}`),
    //验证当前用户是否允许函询--竞标
    getCheckAllowBidQuestion: (tenderNo) => request.get(`${url}/sv1/tender/userInquiry/checkAllowBidQuestion/${tenderNo}`),
    //新增用户函询-竞标
    getSaveForBid: (data) => request.post(`${url}/sv1/tender/userInquiry/saveForBid`, data),
    //新增用户函询-招标
    getSaveForTender: (data) => request.post(`${url}/sv1/tender/userInquiry/saveForTender`, data),
    // 举报
    subReport: (data) => request.post(`${url}/gv1/tender/reporting/add`, data),
    // 招标详情距离计算
    findTenderingDistance: (data) => request.post(`${url}/ov1/mechanicalLabor/findTenderingDistance`, data),
    // 竞价详情距离计算
    findBidDistance: (data) => request.post(`${url}/ov1/mechanicalLabor/findBidDistance`, data),
    // 招标补遗列表
    addendumList: (data) =>
        request.get(`${url}/tender/addendum/page`, data),
    addendumDetail: (no) =>
        request.get(`${url}/tender/addendum/${no}`),
    // 竞价补遗列表
    bidAddendumList: (data) =>
        request.post(`${url}/bid/bidAddendum/list`, data),
    bidAddendumDetail: (no) =>
        request.get(`${url}/bid/bidAddendum/detail/${no}`),
    // 函询 获取类型数据
    getTenderReceiverInquiry: (data) => request.post(`${url}/tenderReceiverInquiry/tenderReceiverByTenderType`, data),
    // 招标函询列表
    getTenderInquiryList:(data) => request.post(`${url}/gv1/tender/userInquiry/findTenderInquiryList`, data),
    // 竞价函询列表
    getBidInquiryList:(data) => request.post(`${url}/gv1/tender/userInquiry/findBidInquiryList`, data),
    // 企业函询 店铺
	getSave: (data) => request.post(`${process.env.VUE_APP_APIUSER}`+'/userInquiry/addInquiry', data),
    // 查询当前用户是否缴纳过竞价保证金
    getPayState: (data) => request.get(`${url}/zcDepositPay/getPayState`, data)

}
export default apiLnquiryLetter
